// Path: src\Components\LeaderBoard\Leaderboard.jsx
import { React, useEffect, useRef, useState } from "react";
import { AppBar, Tabs, Tab, Box } from "@mui/material";
import BaseHome from "../Home/BaseHome";
import { Leaderboard } from "@mui/icons-material";
import TodayLeaderboardbox from './TodayLeaderboardbox'
import WeeklyLeaderboardbox from './WeeklyLeaderboardbox'
import MonthlyLeaderboardbox from './MonthlyLeaderboardbox'
import AllTimeLeaderboardbox from './AllTimeLeaderboardbox'
import { useNavigate } from 'react-router-dom';
import { t } from "i18next";
import TabWithBottomBorder from "../Common/TabWithBottomBorderNewStyle";
const TabPanel = (props) => {

  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box className="tab-content">{children}</Box>}
    </div>
  );
};
const TermsOfUse = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState(0); // Control the selected tab state
  const [style, setStyle] = useState({})
  const [style1, setStyle1] = useState({})
  const handleChange = (event, newValue) => {
    setValue(newValue); // Update the selected tab when changed
  };
  const tabs = [t("leaderboard.today"), t("leaderboard.weekly"), t("leaderboard.monthly"), t("leaderboard.all_time")]
  const [activeTab, setActiveTab] = useState(0)
  const getTabContent = () => {
    // switch (tabs) {
    //   case 0:
    //     return <div className="mytab-content"></div>;
    //   case 1:
    //     return <div className="mytab-content"></div>;

    //   default:
    //     return null;
    // }
  };
  useEffect(() => {
    setValue(activeTab);
  }, [activeTab])
  return (
    <BaseHome isRemoveScroll={true} title={t("leaderboard.leaderboard")} setStyle={setStyle} setStyle1={setStyle1} onBackClick={() => navigate(-1)}>
      <div className="leaderboard--main commontabs commontabs-four" style={{ overflow: 'visible' }}>
            <div className="commontabs-innerwrap tab-backgrounnd-new-style">
              <TabWithBottomBorder getTabContent={getTabContent} tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} setValue={setValue} />
            </div>
          </div>
      <div className="leaderboard--main leaderboard-container-new" >
        <div className="commontabs commontabs-four" style={{ overflow: 'visible' }}>
          <TabPanel className="leaderboard-today" value={value} index={0}>
            <TodayLeaderboardbox style={style} style1={style1} type={"today"} />
          </TabPanel>
          <TabPanel className="leaderboard-today" value={value} index={1}>
            <WeeklyLeaderboardbox style={style} style1={style1} type={"weekly"} />
          </TabPanel>
          <TabPanel className="leaderboard-today" value={value} index={2}>
            <MonthlyLeaderboardbox style={style} style1={style1} type={"monthly"} />
          </TabPanel>
          <TabPanel className="leaderboard-today " value={value} index={3}>
            <AllTimeLeaderboardbox style={style} style1={style1} type={"all-time"} />
          </TabPanel>
        </div>
      </div>
    </BaseHome>
  );
};

export default TermsOfUse;
